module.exports = __webpack_public_path__ + "img/fastcharger-disabled.7a0727e3.png";